import React from 'react';
import t from '~t';

import { Confirm } from '~co/overlay/dialog';
import {
  Item,
  ItemIcon,
  ItemTitle,
  ItemInfo,
  ItemActions,
  Select,
  Button,
} from '~ui';
import { Avatar, Icon } from '~ui'

export default function CollectionSharingCollaboratorsUser({
  _id,
  avatar,
  email,
  name,
  role,
  collection,
  onUserUpdate,
}) {
  const onChangeRole = (e) => {
    const role = e.target.value;
    const userId = parseInt(e.currentTarget.getAttribute('data-userid'));

    if (role && userId) onUserUpdate(userId, { role });
  };

  const onRemove = (e) => {
    const userId = parseInt(e.currentTarget.getAttribute('data-userid'));

    Confirm(t.s('areYouSure'), { variant: 'warning' }).then((yes) => {
      if (yes) onUserUpdate(userId, { role: '' });
    });
  };

  return (
    <Item>
      <ItemIcon>
        <Avatar src={avatar} />
      </ItemIcon>

      <ItemTitle>{name}</ItemTitle>

      <ItemInfo>{email}</ItemInfo>

      {role != 'owner' && collection.access && collection.access.level >= 3 ? (
        <ItemActions>
          <Select
            variant='link'
            value={role}
            data-userid={_id}
            onChange={onChangeRole}
          >
            {role == 'owner' ? (
              <option value='owner'>{t.s('role_owner')}</option>
            ) : null}
            <option value='member'>{t.s('role_member')}</option>
            <option value='viewer'>{t.s('role_viewer')}</option>
          </Select>

          <Button variant='ghost' size='icon' data-userid={_id} onClick={onRemove}>
            <Icon name='trash' />
          </Button>
        </ItemActions>
      ) : null}
    </Item>
  );
}
